export const config = {
    development: false
}